import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './CoolClimateNavigation.css';

export const CoolClimateNavigation: React.FC = () => {
  const location = useLocation();
  const isCalculator = location.pathname === '/coolclimate';

  return (
    <nav className="coolclimate-nav-bar" aria-label="CoolClimate navigation">
      <Link
        to="/"
        className={`coolclimate-nav-item coolclimate-nav-home ${!isCalculator ? 'active' : ''}`}
        aria-current={!isCalculator ? 'page' : undefined}
      >
        Home
      </Link>
      <Link
        to="/coolclimate"
        className={`coolclimate-nav-item coolclimate-nav-calculator ${isCalculator ? 'active' : ''}`}
        aria-current={isCalculator ? 'page' : undefined}
      >
        CoolClimate Calculator
      </Link>
    </nav>
  );
};

